import React from "react";

import "assets/styles/TermsAndConditions.scss";

const PrivacyContent = () => {
    return (
		<div className={'TermsAndConditionsContainer'}>

			<p>
				GRUPO VENDERS MÉXICO S.A. DE C.V. (en adelante "ETOMIN" o "Nosotros"), es la responsable del uso y protección de tus datos personales.
			</p>

			<p>
				Nuestro compromiso con los participantes de nuestro negocio principalmente es la confianza, es por lo que buscamos ser completamente transparentes sobre el tratamiento que le damos a los datos personales de las personas que accedan a nuestro sitio web y de aquellas que utilicen o pretendan utilizar nuestros servicios.
			</p>

			<p>
				El presente aviso de privacidad está dirigido a todos nuestros clientes, prospectos de clientes, a los usuarios finales identificados como usuarios quienes realizan pagos a nuestros clientes a través de ETOMIN así como a los visitantes del sitio https://www.etomin.com/ y relacionados.
			</p>

			<div className={'titlePoint'}>
				FINES PARA EL USO DE DATOS
			</div>

			<div className={'subTitlePoint'}>
				CUÁLES SON LAS FINALIDADES PRIMARIAS
			</div>

			<p>
				Si deseas ser o eres un cliente de ETOMIN, nosotros podremos usar tus datos personales para las siguientes finalidades que son necesarias para brindarte nuestros servicios:
			</p>

			<ul style={{listStyle: 'disc', paddingLeft: '40px', marginBottom: '20px'}}>
				<li>Para registrarte en nuestra plataforma informática.</li>
				<li>Para confirmar tu identidad.</li>
				<li>Para validar tu información.</li>
				<li>Para realizar análisis, para determinar los productos y/o servicios que más se ajusten a tus necesidades como usuario de ETOMIN.</li>
				<li>Para comunicarnos contigo en relación con los productos y/o servicios que estás interesado en contratar o que podemos ofrecerte por parte de ETOMIN.</li>
				<li>Para que contrates productos y/o servicios que preste ETOMIN.</li>
				<li>Para activarte como cliente y activar una cuenta asociada a ti o a la persona moral que contrata servicios de ETOMIN.</li>
				<li>Para comunicarnos en relación con los productos y/o servicios que tienes contratados con ETOMIN.</li>
				<li>Para alimentar, desarrollar y optimizar nuestros sistemas antifraude.</li>
				<li>Para cooperar con autoridades competentes y con otros participantes en las redes de medios de disposición en la investigación de posibles actividades ilícitas.</li>
				<li>Para resolver controversias o disputas relacionadas con los Servicios que presta ETOMIN.</li>
			</ul>

			<p>
				Si eres un usuario final que realizas un pago a través de ETOMIN tus datos personales los utilizamos para las siguientes finalidades que son necesarias para la prestación de nuestros servicios:
			</p>

			<ul style={{listStyle: 'disc', paddingLeft: '40px', marginBottom: '20px'}}>
				<li>Para confirmar tu identidad.</li>
				<li>Para validar tu información.</li>
				<li>Para alimentar, desarrollar y optimizar nuestros sistemas antifraude.</li>
				<li>Para cooperar con autoridades competentes y con otros participantes en las redes de medios de disposición en la investigación de posibles actividades ilícitas.</li>
				<li>Para procesar los pagos que realices a alguno de nuestros clientes.</li>
				<li>Para brindarte atención o canalizarte con quien pueda brindarte atención en relación con tus pagos procesados a través de Etomin.</li>
				<li>Para brindarte distintas alternativas para el pago de productos y servicios.</li>
			</ul>

			<div className={'subTitlePoint'}>
				CUÁLES SON LAS FINALIDADES SECUNDARIAS
			</div>

			<p>
				ETOMIN podrá usar de manera adicional, los datos de nuestros clientes, prospectos de clientes y usuarios finales para los siguientes fines adicionales:
			</p>

			<ul style={{listStyle: 'disc', paddingLeft: '40px', marginBottom: '20px'}}>
				<li>Para fines mercadotécnicos, publicitarios o de prospección comercial, incluyendo publicidad y promociones propias o de nuestros socios comerciales.</li>
				<li>Para evaluar la calidad de nuestro proceso de registro de clientes.</li>
				<li>Para realizar análisis, clasificaciones y segmentaciones a efecto de determinar los productos y/o servicios propios o de terceros que más se ajusten a tus necesidades.</li>
				<li>Para informar a los sectores involucrados con los medios de pago sobre los usuarios de ETOMIN</li>
			</ul>

			<p>
				En caso de que no desees que tus datos personales sean tratados para estas finalidades secundarias o adicionales, puedes manifestar tu negativa al respecto manifestado esta voluntad por escrito a los medios indicados para el caso.
			</p>

			<p>
				La negativa al uso y tratamiento de tus datos personales para las finalidades adicionales o secundarias no será motivo para que neguemos la prestación de nuestros servicios y productos.
			</p>

			<div className={'titlePoint'}>
				DATOS PERSONALES QUE RECABAMOS
			</div>

			<p>
				ETOMIN para llevar a cabo las finalidades descritas en este aviso de privacidad, recabamos las siguientes categorías de datos personales de nuestros clientes y/o prospectos:
			</p>

			<ul style={{listStyle: 'disc', paddingLeft: '40px', marginBottom: '20px'}}>
				<li>Datos de identificación personal</li>
				<li>Datos de contacto</li>
				<li>Datos patrimoniales o financieros</li>
				<li>Datos comerciales</li>
				<li>Datos de tus clientes y/o usuarios finales, incluyendo datos financieros y patrimoniales que utilizamos para el procesamiento de los pagos electrónico</li>
			</ul>

			<p>
				De los usuarios finales recabamos las siguientes categorías de datos personales:
			</p>

			<p>
				En ETOMIN no usamos ni recolectamos ni tratamos datos personales sensibles.
			</p>

			<p>
				De conformidad con la LFPDPPP para el tratamiento de tus datos personales financieros o patrimoniales requerimos tu consentimiento expreso y por escrito, por lo que al aceptar este aviso de privacidad por medios electrónicos, también aceptas el tratamiento de tus datos financieros o patrimoniales.
			</p>

			<div className={'titlePoint'}>
				DATOS QUE COMPARTIMOS CON DIFERENTES ENTIDADES Y EL MOTIVO
			</div>

			<p>
				ETOMIN para la prestación de los servicios que provee y a lo largo de nuestra relación comercial contigo podremos transmitir tus datos personales con las siguientes categorías de terceros y para las finalidades que señalamos a continuación:
			</p>

			<ul style={{listStyle: 'disc', paddingLeft: '40px', marginBottom: '20px'}}>
				<li>Sociedades subsidiarias, filiales o que forman parte de nuestro grupo corporativo con la finalidad de consolidar la información corporativa y comercial y brindar los servicios que ofrecemos de acuerdo a las necesidades comerciales de Etomin. Por ejemplo, algunos de los empleados del grupo corporativo trabajan para sociedades constituidas fuera del territorio nacional.</li>
				<li>Proveedores de servicios de tecnología, almacenamiento y bases de datos, analítica, seguridad de la información, soporte técnico, call center, mercadotecnia, sistemas antifraude, consultoría, jurídicos, así como cualquier otro servicio que resulte necesario para el desempeño de nuestros servicios. Estos terceros asumen nuestras mismas obligaciones respecto a la protección de tus datos personales. Nuestros proveedores son evaluados por nuestro departamento de seguridad de la información, nos aseguramos de que contractualmente: (i) sólo utilicen los datos personales conforme a nuestras instrucciones, y (ii) cuenten con las medidas de seguridad de la información adecuadas en relación con el servicio que nos brindan;*</li>
				<li>Instituciones financieras y otras entidades participantes en la red de medios de disposición para el procesamiento de los pagos;</li>
				<li>Nuestros socios comerciales o aliados estratégicos, ya sea porque resulta necesaria su participación en la prestación de nuestros servicios o porque consideramos que podrían ofrecerte productos o servicios de tu interés;</li>
				<li>Autoridades, organismos o entidades gubernamentales; en cumplimiento a las obligaciones contempladas en la legislación aplicable y/o en cumplimiento de requerimientos efectuados por las mismas, principalmente en materia de prevención de lavado de dinero;</li>
				<li>Empresas de cobranza, para la recuperación de adeudos y su cobro judicial o extrajudicial;</li>
				<li>Inversionistas o posibles inversionistas con la finalidad de que evalúen nuestras relaciones comerciales y la pertinencia de invertir en ETOMIN.</li>
			</ul>

			<p>
				Al aceptar este aviso de privacidad entendemos que también nos otorgas tu consentimiento sobre estas transferencias.
			</p>

			<p>
				Además, si eres un usuario final, te informamos que tus datos personales también los compartimos con nuestros clientes, a excepción de aquellos datos financieros que no podamos compartir por cuestiones de cumplimiento con la certificación PCI DSS relativa a la seguridad de los datos en la industria de pagos con tarjeta.
			</p>

			<div className={'titlePoint'}>
				DERECHOS ARCO Y/O REVOCACIÓN DE CONSENTIMIENTO SOBRE EL TRATAMIENTO DE MIS DATOS PERSONALES
			</div>

			<p>
				Como usuario de los servicios que presta ETOMIN como usuario te invitamos a ejercer el derecho de acceso, rectificación, cancelación u oposición ("Derechos ARCO") o a revocar tu consentimiento sobre el tratamiento de tus datos personales a través de escrito enviado a los medios de contacto autorizados para este fin.
			</p>

			<p>
				En caso de que tu solicitud no cumpla con alguno de los requisitos, te contactaremos para solicitarte información adicional dentro de los cinco días hábiles siguientes a tu solicitud. En caso de no recibir esta información dentro de los siguientes diez días hábiles, tendremos que desechar tu solicitud. Daremos respuesta a tu solicitud dentro de los veinte días hábiles siguientes a haber recibido la misma sin ningún defecto y con la información necesaria para procesarla.
			</p>

			<div className={'titlePoint'}>
				MECANISMOS ADICIONALES ME PERMITEN LIMITAR EL USO O DIVULGACIÓN DE MIS DATOS PERSONALES
			</div>

			<p>
				ETOMIN, cuenta con un listado de exclusión de correos electrónicos, en caso de que no desees seguir recibiendo correos electrónicos con fines publicitarios de parte nuestra, podrás deshabilitar tu suscripción en cualquier momento a través del link que encontrarás al final de cada correo.
			</p>

			<p>
				Adicionalmente, puedes limitar el uso o divulgación de tus datos personales inscribiéndote en el Registro Público para Evitar Publicidad, que está a cargo de la Procuraduría Federal del Consumidor. Esto evitará que tus datos personales sean utilizados para recibir publicidad o promociones de empresas de bienes o servicios. Para mayor información sobre este registro, puedes consultar el portal de internet de la PROFECO, o ponerte en contacto directo con ésta.
			</p>

			<div className={'titlePoint'}>
				COOKIES, WEB BEACONS Y OTRAS TECNOLOGÍAS DE RASTREO
			</div>

			<p>
				ETOMIN en algún momento dentro de nuestra página de Internet utilizamos cookies, web beacons y otras tecnologías a través de las cuales nos es posible monitorear tu comportamiento como usuario de internet, brindarte un mejor servicio y experiencia de usuario al navegar en nuestra página, y ofrecerte nuevos productos y servicios basados en tus preferencias.
			</p>

			<p>
				Algunos de los datos personales que obtenemos con estas tecnologías son: horario de navegación, tiempo de navegación en nuestra página de internet, secciones consultadas, y páginas de internet accedidas previo a la nuestra.
			</p>

			<div className={'titlePoint'}>
				CONTACTO
			</div>

			<p>
				ETOMIN pone a su disposición los medios de contacto para ejercer cualquier derecho o solicitud consagrada en esta política de privacidad
			</p>

			<p>
				<strong>CORREO ELECTRÓNICO:</strong> comercial@etomin.com
			</p>

			<p>
				<strong>DIRECCIÓN:</strong> Av. Constituyentes 908, Col. Lomas Altas, Del. Miguel Hidalgo, Ciudad de México, CP 11950
			</p>

			<p>
				<strong>EN ATENCIÓN A:</strong> PERSONAL ESPECIALIZADO ETOMIN
			</p>

			<p style={{marginTop: '40px', textAlign: 'center', fontStyle: 'italic'}}>
				Última fecha de actualización noviembre de 2025
			</p>

		</div>
    );

}

export default PrivacyContent;
